<template>

  <div class="access-form">

    <slot></slot>

    <data-form
      :entity="formModel"
      :fields="fields"
      @change="onChange"
      hide-buttons
      :disabled="disabled"
      >

        <template v-if="!buttons">

          <el-button
            v-if="!unlocked"
            type="primary"
            :disabled="!!access.pending_access_id || !!access.hasOwnProperty('attempts')"
            @click="unlocked = true">{{ $t('button.edit') }}</el-button>

          <template v-else>

            <el-button
              type="primary"
              @click="saveAccess">{{ $t('button.save-scheduled') }}</el-button>

            <el-button
              type="warning"
              @click="sendAccess">{{ $t('button.send') }}</el-button>

            <el-button @click="unlocked = false">{{ $t('button.cancel') }}</el-button>

          </template>

          <span v-if="access.pending_access_id">{{ $t('label.has-pending-access') }}</span>

        </template>

        <template v-else>
          <el-button
            v-for="b in buttons"
            @click="() => b.action(formModel)">{{ $t('button.' + b.title) }}</el-button>
        </template>

      </data-form>

  </div>

</template>

<script>
import days from './days'
import userLevels from './userLevels'

export default {
  name: 'access-form',
  props: {
    access: {
      type: Object,
      required: true
    },
    buttons: {
      type: Array
    },
    additionalFields: {
      type: Object,
      default: () => ({})
    },
    hideUserLevel: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showRegStatus: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const formModel = this._fillDefaultsToAccess(this.access)

    return {
      unlocked: false,
      formModel
    }
  },
  computed: {
    fields () {
      let fields = {}

      if (this.showRegStatus) {
        fields = {
          'registration_status_switch_value': {
            type: 'switch',
            label: 'has-access'
          }
        }

        if (!this.formModel.registration_status_switch_value) {
          return fields
        }
      }

      fields = {
        ...fields,
        'key_type': {
          type: 'radio',
          options: [
            {
              value: 'constant',
              label: 'keyType.constant'
            },
            {
              value: 'temporary',
              label: 'keyType.temporary'
            },
            {
              value: 'recurring',
              label: 'keyType.recurring'
            }
          ]
        }
      }

      if (!this.hideUserLevel) {
        fields = {
          'user_level_id': {
            type: 'select',
            options: userLevels
          },
          ...fields
        }
      }

      if (this.formModel.key_type === 'constant') {
        fields = {
          ...fields,
          'start_date': { type: 'datetime', format: 'yyyy-MM-dd HH:mm' }
        }
      }
      else if (this.formModel.key_type === 'temporary') {
        fields = {
          ...fields,
          'start_date': { type: 'datetime', format: 'yyyy-MM-dd HH:mm' },
          'end_date': { type: 'datetime', format: 'yyyy-MM-dd HH:mm' }
        }
      }
      else {
        fields = {
          ...fields,
          'start_date': { type: 'date' },
          'end_date': { type: 'date' },
          'duration': { type: 'time', format: 'HH:mm' },
          'days': {
            type: 'select',
            options: days,
            multiple: true
          }
        }
      }

      return { ...this.additionalFields, ...fields }
    }
  },
  methods: {
    saveAccess () {
      this.submitAccess(true)
    },
    sendAccess () {
      this.submitAccess(false)
    },
    submitAccess (scheduled) {
      this.$emit('submit', this._formatAccess(this.formModel, scheduled), scheduled)
      this.unlocked = false
    },
    onChange (val) {
      this.formModel = val
      this.$emit('change', this._formatAccess(val))
    },
    _formatAccess (formModel, scheduled) {
      const {
        id = 'new',
        switch_id,
        mobile_id,
        user_id,
        registration_status = 'active',
        user_level_id,
        key_type,
        start_date,
        end_date
      } = formModel

      if (this.showRegStatus && !formModel.registration_status_switch_value) {
        return { registration_status: 'none' }
      }

      const data = {
        id,
        switch_id,
        mobile_id,
        user_id,
        registration_status,
        user_level_id,
        key_type,
        start_date,
        scheduled
      }

      if (key_type !== 'constant') {
        data.end_date = end_date

        if (key_type !== 'temporary') {
          const from = new Date(formModel.duration[0])
          const to = new Date(formModel.duration[1])

          data.start_hour = from.getHours()
          data.start_minute = from.getMinutes()
          data.end_hour = to.getHours()
          data.end_minute = to.getMinutes()

          data.days = JSON.stringify(formModel.days)
        }
      }

      return data
    },
    _fillDefaultsToAccess (access) {
      function now () {
        const now = new Date()
        now.setSeconds(0)

        return now
      }

      const _access = Object.assign({}, {
        user_level_id: 1,
        key_type: 'constant',
        start_date: now(),
        end_date: now(),
        duration: [now(), now()],
        days: [],
        registration_status: 'active',
        registration_status_switch_value: ['active', 'peding'].includes(access.registration_status)
      }, access)

      if (!(_access.start_date instanceof Date)) {
        _access.start_date = new Date(_access.start_date)
        _access.start_date.setSeconds(0)
      }

      if (!(_access.end_date instanceof Date)) {
        _access.end_date = new Date(_access.end_date)
        _access.end_date.setSeconds(0)
      }

      if (typeof _access.days === 'string') {
        _access.days = JSON.parse(_access.days)
      }

      this.$emit('change', this._formatAccess(_access))

      return _access
    }
  },
  watch: {
    // Handle whenever a new acces is selected from the list
    access: {
      handler (newValue) { this.formModel = this._fillDefaultsToAccess(newValue) },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// AccessForm.vue?1992a984